import React, { useContext, useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import "../../styles/newbusiness.css";
import { useLocation, useNavigate } from "react-router-dom";
import { CourseContext } from "../../context/CourseContext";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import

const BusinessLandingPage = () => {
  const { t } = useTranslation("BusinessLandingPage");
  const { user } = useContext(CourseContext);
  const navigate = useNavigate();
  const location = useLocation();
  const cards = [
    {
      id: 1,
      imageSrc: "/new-business/landing-1.webp",
      title: t("business_1_title"),
      description: t("business_1_description"),
    },
    {
      id: 2,
      imageSrc: "/new-business/landing-2.webp",
      title: t("business_2_title"),
      description: t("business_2_description"),
    },
    {
      id: 3,
      imageSrc: "/new-business/landing-3.webp",
      title: t("business_3_title"),
      description: t("business_3_description"),
    },
    {
      id: 4,
      imageSrc: "/new-business/landing-4.webp",
      title: t("business_4_title"),
      description: t("business_4_description"),
    },
    {
      id: 5,
      imageSrc: "/new-business/landing-5.webp",
      title: t("business_5_title"),
      description: t("business_5_description"),
    },
  ];

  const handleNavigate = () => {
    if (user?.role) {
      navigate("/trail/overview-step", {
        state: {
          trailId: location?.state?.trailId,
          name: location?.state?.name,
        },
      });
    } else {
      navigate("/sign-in");
    }
  };

  useEffect(() => {
    if (!location?.state?.trailId) {
      navigate("/trail-list");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Header />
      <main>
        <section className="new_business_landing">
          <div className="team-pricing overflow-hidden d-flex justify-content-center align-items-center">
            <div className="container">
              <div className="row justify-content-between align-items-center">
                <div className="col-12 col-md-6 col-lg-6 order-2 order-md-1">
                  {user?.main_role === 1 || user?.role === 2 ? (
                    <>
                      <h2 className="display-5 text-start text-white fw-400 mb-3">
                        {t(
                          "empower_learning_paths"
                        )}
                      </h2>
                      <p className="text-start text-white fs-6 fw-300 mb-4">
                        {/* Interactive training for {location.state.name}, designed for professionals. */}
                      </p>
                    </>
                  ) : (
                    <>
                      <h2 className="display-5 text-start text-white fw-400 mb-3">
                        {t("safeOnlineKids")}
                      </h2>
                      <p className="text-start text-white fs-6 fw-300 mb-4">
                        {t("coursesForKidsParents")}
                      </p>
                    </>
                  )}
                  <button
                    onClick={handleNavigate}
                    className="btn btn-warning text-black d-inline-flex align-items-center gap-3 fw-600 fs-18 w-auto"
                  >
                    {t("startfreetrial")}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={22}
                      height={14}
                      viewBox="0 0 22 14"
                      fill="none"
                    >
                      <path
                        d="M1 6.99854H21L16 1"
                        stroke="#000C2A"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M21 6.99854L16 13"
                        stroke="#000C2A"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                </div>
                <div className="col-12 col-md-6 col-lg-6 position-relative d-flex justify-content-end order-1 order-md-2">
                  <div>
                    <img
                      src="../../individual-pricing/team-pricing-vector-3.png"
                      className="team-pricing-vector-3"
                      alt=""
                    />
                    <img
                      src="../../individual-pricing/boy-and-girl.png"
                      className="boy-and-girl position-relative z-1"
                      alt=""
                    />
                    <img
                      src="../../individual-pricing/team-pricing-vector-4.png"
                      className="team-pricing-vector-4"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="unique-edge-main position-relative ">
            <div className="container">
              {user?.main_role === 1 || user?.role === 2 ? (
                <div className="section-title">
                  <span className="d-block fs-18">{t("unqiueedge")}</span>
                  <h2 className="mb-3 col-md-12 col-lg-6 m-auto mt-3">
                    {t("unlockyourlearningpotential")}
                  </h2>
                  <p className="text-center mb-0 col-md-12 col-lg-9 m-auto fs-19 sm-fs-14 text-muted">
                    {t("sectiontitledesp")}
                  </p>
                </div>
              ) : (
                <div className="section-title">
                  <span className="d-block fs-18">{t("unqiueedge")}</span>
                  <h2 className="mb-3 col-md-12 col-lg-6 m-auto mt-3">
                    {t("onlinesafetyforkids")}
                  </h2>
                </div>
              )}

              <div className="row row-cols-2 row-cols-md-2 row-cols-lg-3 new_business_unique_edge_card g-3 g-md-4">
                {cards.map((card) => (
                  <div className="col" key={card.id}>
                    <div className="card h-100">
                      <div className="card-body">
                        <img src={card.imageSrc} alt={card.title} />
                        <h3>{card.title}</h3>
                        <p>{card.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <img
              src="/unique-edge/yellow-vector.png"
              className="new_business_unique_vector_yellow"
              alt=""
            />
            <img
              src="/unique-edge/pink-vector.png"
              className="new_business_unique_vector_pink"
              alt=""
            />
            <img
              src="/unique-edge/light-green-vector.png"
              className="new_business_unique_vector_green"
              alt=""
            />
          </div>
        </section>
        <section className="new_business_account_quick text-center">
          <div className="container">
            <span>{t("jointhelearningadventure")} </span>
            <h3>{t("freeAccountCreation")} </h3>
            <p>
              {t(
                "dontmissdes"
              )}{" "}
            </p>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                className="btn-explore p-sm-15 d-inline-flex align-items-center gap-3 rounded-2 mt-4"
              >
                {t("signupandstrartfreetrial")}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={22}
                  height={14}
                  viewBox="0 0 22 14"
                  fill="none"
                >
                  <path
                    d="M1 6.99854H21L16 1"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M21 6.99805L16 12.9995"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default BusinessLandingPage;
